import {useCallback, useMemo} from "react";
import {OrganManagerShareFilterWordType} from "../../../../types/organShare";

export function useOrganManagerShareConverter() {
    const searchWordConverter = useMemo(
        () => ({
            [OrganManagerShareFilterWordType.MANAGER_ID.toString()]: "관리자 아이디",
            [OrganManagerShareFilterWordType.MANAGER_NAME.toString()]: "관리자 이름",
            [OrganManagerShareFilterWordType.CELL_PHONE.toString()]: "관리자 전화번호",
        }), []
    );

    const getSearchWordConverter = useCallback(
        (status: OrganManagerShareFilterWordType) => searchWordConverter[status.toString()],
        [searchWordConverter]
    );

    return {
        getSearchWordConverter
    }
}